import { useEffect } from "react";
import { useGetUser } from "../auth/useGetUser";
import { initAdtraceWithExternalId } from "../../lib/adtrace";

const ADTRACE_ENABLED =
  import.meta.env.VITE_ADTRACE_ENABLE === "true" &&
  !!import.meta.env.VITE_ADTRACE_APP_TOKEN;

export default function AdtraceGate() {
  const { isPending, isError, user } = useGetUser();

  useEffect(() => {
    if (!ADTRACE_ENABLED || isPending) return;

    const userId = !isError && user?.id != null ? String(user.id) : undefined;
    if (userId) {
      initAdtraceWithExternalId(userId); // sets/overwrites externalDeviceId
    }
  }, [isPending, isError, user?.id]);

  return null;
}
